import { OK, SERVICE_UNAVAILABLE } from 'shared/contants';

/** Signed URL(s) of a public link, or the status the server refused it with. */
export interface SharedResourceSignedRequestResult {
  statusCode: number;
  signedRequest?: string | string[];
}

/** A document shared through a public issue link. */
export interface SharedDocumentSignedUrlRequest {
  issueId: string;
  documentId: string | undefined;
  token: string;
  eventId?: string;
  incomingEmailMessageId?: string;
  linkedDocumentationId?: string;
}

/** A report shared through a public link. */
export interface SharedReportSignedUrlRequest {
  reportId: string;
  token: string;
}

interface SignedRequestResponseBody {
  type?: 'single' | 'multi';
  signedRequest?: string | null;
  signedRequests?: string[] | null;
}

function isSignedRequestResponseBody(body: unknown): body is SignedRequestResponseBody {
  return typeof body === 'object' && body !== null;
}

/**
 * Reads the server's answer to a public link: the signed URL (a list for a
 * multi-file report) on 200, otherwise only the status.
 */
export function readSharedResourceSignedRequest(
  statusCode: number,
  body: unknown
): SharedResourceSignedRequestResult {
  if (statusCode !== OK) {
    return { statusCode };
  }
  if (!isSignedRequestResponseBody(body)) {
    return { statusCode: SERVICE_UNAVAILABLE };
  }

  const signedRequest =
    body.type === 'multi'
      ? body.signedRequests ?? undefined
      : body.signedRequest ?? undefined;

  return { statusCode: OK, signedRequest };
}
